import React, { useState, useEffect, useRef } from "react";
import "../selecting/Sap.css";
import { ArrowLeftOutlined, DoubleRightOutlined } from '@ant-design/icons';
import axios from "axios";
import { host } from "../variables.js";
import { get } from "lodash";
import { Button} from 'antd';
import { Modal } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';


const App = () => {
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState([]);
  const [matchesData, setMatchesData] = useState([]);
  const [currentDoc, setCurrentDoc] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showBookingTable, setShowBookingTable] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [history, setHistory] = useState([]);
  const [imageSrc, setImageSrc] = useState(null);
  const currentIndexRef = useRef(currentIndex);
  const [remarks, setRemarks] = React.useState("");
  const [confidence, setConfidence] = useState(false)
  const [manualUnmatch, setManualUnmatch] = useState(false)
  const [modalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const { documentId } = useParams();
  const location = useLocation();
  const isDocumentPage = location.pathname.includes('/selecting/') && location.pathname.split('/').length > 2;
  const [countValues, setCountValues] = useState(0)
  const [filterAppliedValue, setFilterAppliedValue] = useState(0)
 


  const fetchData = async () => {
    try {
      console.log("Fetching next document from backend...");
      const response = await axios.get(`${host}/matches`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          documentId: documentId,
        },
      });
      let response_data = response.data.data;
      setMatchesData(response_data);
      const selectedData = response_data
        .flatMap(entry => entry.MATCHES || []) 
        .flatMap(match => match?.RESPECTIVE_GST_DATA || [])
        .map(gstData => gstData?._id) 
        .filter(id => id !== undefined)
      const selectedColumnId = response_data
        .filter(entry => entry.SELECTED_GST_DATA) 
        .flatMap(entry => entry.SELECTED_GST_DATA?.RESPECTIVE_GST_DATA || []) 
        .map(gstData => gstData?._id) 
        .filter(id => id !== undefined); 
      if (selectedColumnId.length > 0) {
        const selectedColumn = selectedColumnId.map(id => selectedData.indexOf(id));
        setSelectedColumn(selectedColumn);
      }
      const remarksData = response_data.map(entry => entry.REMARKS || "");
      setRemarks(remarksData);
      if (response_data.length > 0) {
        setCurrentDoc(createDoc(response_data[0]));
      }
    } catch (error) {
      console.error("Error fetching the next document:", error);
      return null;
    }
  };


  useEffect(() => {
    if (documentId) {
      fetchData();
    } else {
      fetchMatchesData();
    }
  }, [documentId]);

  const handleRemarksChange = (event) => {
    setRemarks(event.target.value);
  };

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOkMatches = () => {
    setIsModalVisible(false);
    navigate('/outputTable');
  };

  const handleCancelMatches = () => {
    setIsModalVisible(false);
  };
  const fetchMatchesData = async () => {
    try {
      const response = await axios.get(`${host}/matches`, { "ngrok-skip-browser-warning": "fsdfsd" });
      let response_data = response.data.data;
      setCountValues(response.data.count_values || 0);
      setFilterAppliedValue(response.data.count_filter_applied || 0);
      setMatchesData(response_data);

      if (response_data.length > 0) {
        const firstDoc = createDoc(response_data[0]);
        setCurrentDoc(firstDoc);
        setHistory((prevHistory) => [
          ...prevHistory,
          {
            doc: firstDoc,
            selected: selectedColumn,
            countValues: response.data.count_values,
            filterAppliedValue: response.data.count_filter_applied
          },
        ]);
      } else {
        setIsModalVisible(true);
      }
    } catch (error) {
      console.error("Error fetching matches data:", error);
    }
  };

  const getDataFromLodash = (obj, paths) => {
    for (const path of paths) {
      const value = get(obj, path);
      if (value !== undefined) {
        return value; 
      }
    }
    return " "; 
  };

  const createDoc = (docData) => {
    console.log(docData, "doc data")
    setPdfUrl(docData.url); 
    console.log(docData._id, "object id")

    return {
      _id: docData._id,
      url: docData.url,

      df_A: {
        supplier_name: docData.PROCESSED_INVOICE_DATA?.hotel_name || "N/A",
        seller_vat_number: docData.PROCESSED_INVOICE_DATA?.hotel_gstin || "N/A",
        invoice_number: docData.PROCESSED_INVOICE_DATA?.invoice_number || "N/A",
        invoice_amount: docData.PROCESSED_INVOICE_DATA?.invoice_amount || "N/A",
        countValues: countValues,
        filterAppliedValue: filterAppliedValue,
        invoice_date: getDataFromLodash(docData.PROCESSED_INVOICE_DATA, [
          "invoice_date",
          "dt",
        ]),
      },
      df_B:
        docData.MATCHES?.map((match) => ({
          trdnm: getDataFromLodash(match.RESPECTIVE_GST_DATA, [
            "supplier_name",
            "vendor_name",
            "vendor_name_2b",
          ]),
          gstTable: match.GST_TABLE ?? match.GST_TABLE ?? "N/A",

          ctin: getDataFromLodash(match.RESPECTIVE_GST_DATA, [
            "supplier_gstin",
            "gstin",
            "vendor_gstin",
          ]),

          inum: getDataFromLodash(match.RESPECTIVE_GST_DATA, [
            "invoice_number",
            "inum",
          ]),

          val: getDataFromLodash(match.RESPECTIVE_GST_DATA, [
            "invoice_value",
            "val",
            "total_amount",
          ]),

          dt: getDataFromLodash(match.RESPECTIVE_GST_DATA, [
            "invoice_date",
            "dt",
          ]),

          gstin_score: match.SCORES.gstin_score || 0,
          inv_no_score: match.SCORES.number_score || 0,
          amount_score: match.SCORES.amount_score || 0,
          date_score: match.SCORES.date_score || 0,
          combined_score: match.SCORES.combined_score || 0,
        })) || [],
      booking_data: docData.booking_data || "N/A",
    };
  };

  const handleNextClick = async (confidence, manualUnmatch) => {
    const selectedData = matchesData[currentIndex]?.MATCHES[selectedColumn] || [];
    const documentId = currentDoc?._id;
    if (!documentId) {
      console.error("Document ID is not defined");
      return;
    }
    try {
      await axios.post(
        `${host}/saveSelectedColumn?documentId=${documentId}`,
        {
          selectedData,
          remarks,
          confidence: confidence,
          manualUnmatch: manualUnmatch
        }
      );
      console.log("Data saved successfully");
      if (isDocumentPage) {
        navigate("/outputTable")
      } else {
        const nextDocData = await fetchNextDocument();
       
        if (currentIndex >= matchesData.length - 1) {
          setModalVisible(true);
        }
        if (nextDocData) {
          setHistory((prevHistory) => [
            ...prevHistory,
            { doc: currentDoc, selected: selectedColumn, currentIndex, matchesData, countValues, filterAppliedValue, remarks },
          ]); 
          setSelectedColumn([]);

          setCountValues(countValues)
          setFilterAppliedValue(filterAppliedValue)

          setCurrentDoc(createDoc(nextDocData));
          setCurrentIndex((prevIndex) =>
            Math.min(prevIndex + 1, matchesData.length - 1)
          );
          setRemarks(" ");
        } else {
          showModal();
        }
      }
    } catch (error) {
      console.error("Error during confirmation handling:", error);
    }
  };


  const fetchNextDocument = async () => {
    try {
      console.log("Fetching next document from backend...");
      const response = await axios.get(`${host}/nextDocument`, {
        headers: {
          "Content-Type": "application/json",
        },
        params: {
          documentId: currentDoc?._id,
        },
      });
      const nextDocData = response.data.data;
      const newMatchesData = Array.isArray(nextDocData) ? nextDocData : [nextDocData];

      setMatchesData(newMatchesData);
      setCurrentIndex(0);
      setCountValues(response.data.count_values)
      setFilterAppliedValue(response.data.count_filter_applied)
      return nextDocData ? nextDocData : null;
    } catch (error) {
      console.error("Error fetching the next document:", error);
      return null;
    }
  };

  const updateDocumentDisplay = (doc) => {
    if (doc?.url) {
      if (doc.url.endsWith(".pdf")) {
        setPdfUrl(doc.url);
        console.log(pdfUrl);
        setImageSrc(null);
      } else {
        setImageSrc(doc.url);
        console.log(imageSrc);
        setPdfUrl(null);
      }
    } else {
      setPdfUrl(null);
      setImageSrc(null);
    }
  };

  const handleMatch = async () => {
    console.log("No clicked");
    const manualUnmatch = true
    const confidence = false
    setManualUnmatch(true)
    setConfidence(false)
    await handleNextClick(confidence, manualUnmatch);
  };

  const handlePerfectMatch = async () => {
    console.log("Yes clicked");
    const manualUnmatch = true
    const confidence = true
    setManualUnmatch(true)
    setConfidence(true)
    await handleNextClick(confidence, manualUnmatch);
  };

  const handlePrevious = async () => {
    fetchPreviousDocument();
  };


  const handleSkip = async () => {
    const documentId = currentDoc?._id;
    setManualUnmatch(false)

    if (!documentId) {
      console.error("Document ID is not defined");
      return;
    }

    try {
      await axios.post(
        `${host}/saveSelectedColumn?documentId=${documentId}`,
        {
          remarks,
          manualUnmatch: false,
          confidence: false

        }
      );
      if (isDocumentPage) {
        navigate("/outputTable")
      } else {
        const nextDocData = await fetchNextDocument();

        if (nextDocData) {
          setHistory((prevHistory) => [
            ...prevHistory,
            { doc: currentDoc, selected: selectedColumn, countValues: countValues, filterAppliedValue: filterAppliedValue },
          ]);
          setSelectedColumn([]);
          setCurrentDoc(createDoc(nextDocData));
          console.log(currentDoc, "current doc");
          setCurrentIndex((prevIndex) =>
            Math.min(prevIndex + 1, matchesData.length - 1)
          );
          setRemarks("");
        } else {
          showModal();
        }
      }
    } catch (error) {
      console.error("Error during skip handling:", error);
    }
  };

  const handleNoMatchFound = async () => {
    const documentId = currentDoc?._id;
    setManualUnmatch(true)

    if (!documentId) {
      console.error("Document ID is not defined");
      return;
    }

    try {
      await axios.post(
        `${host}/saveSelectedColumn?documentId=${documentId}`,
        {
          remarks,
          manualUnmatch: false,
          confidence: true

        }
      );
      if (isDocumentPage) {
        navigate("/outputTable")

      } else {
        const nextDocData = await fetchNextDocument();

        if (nextDocData) {
          setHistory((prevHistory) => [
            ...prevHistory,
            { doc: currentDoc, selected: selectedColumn },
          ]);
          setSelectedColumn([]);
          setCurrentDoc(createDoc(nextDocData));
          console.log(currentDoc, "current doc");
          setCurrentIndex((prevIndex) =>
            Math.min(prevIndex + 1, matchesData.length - 1)
          );
          setRemarks("");
        } else {
          showModal();
        }
      }


    } catch (error) {
      console.error("Error during skip handling:", error);
    }
  };
  const getColor = (value) => {
    if (value > 80) {
      return {
        textColor: '#1E7734',
        backgroundColor: '#F1FCF3',
        borderColor: '#C0F2CC'
      };
    } else if (value >= 50 && value <= 80) {
      return {
        textColor: '#E26E00',
        backgroundColor: '#FFFBEA',
        borderColor: '#E26E00'
      };
    } else {
      return {
        textColor: '#E53935',
        backgroundColor: '#FFCCCB',
        borderColor: '#E53935'
      };
    }
  };

  const showNoMatchFound = selectedColumn.length === 0;
  const showPerfectMatchAndMatch = selectedColumn.length > 0;

  const fetchPreviousDocument = async () => {
    if (history.length === 0) {
      return;
    }
    const prevEntry = history[history.length - 1];
    console.log(prevEntry,"Prev entry")
    const prevDocument = prevEntry.doc;
    const prevSelectedColumn = prevEntry.selected;
    const prevIndex = prevEntry.currentIndex;
    const prevMatchesData = prevEntry.matchesData;
    const prevCountValues = prevEntry.countValues;
    const prevFilterAppliedValue = prevEntry.filterAppliedValue;
    const prevRemarks=prevEntry.remarks;
    setCountValues(prevCountValues);
    setFilterAppliedValue(prevFilterAppliedValue);
    setCurrentDoc(prevDocument);
    setSelectedColumn(prevSelectedColumn || []);
    setCurrentIndex(prevIndex || 0);
    setMatchesData(prevMatchesData || []);
    setHistory((prevHistory) => prevHistory.slice(0, -1));
    setCurrentIndex((prevIndex) => Math.max(0, prevIndex - 1));
    updateDocumentDisplay(prevDocument);
    setRemarks(prevRemarks);
  };
 
  const moveToOutputTable = () => {
    navigate("/outputTable")
  }

  const handleCheckboxChange = (idx) => {
    setSelectedColumn(prevSelectedColumn => {
      if (prevSelectedColumn.includes(idx)) {
        return prevSelectedColumn.filter(col => col !== idx);
      } else {
        return [...prevSelectedColumn, idx];
      }
    });
  };


  return (
    <div className="fullScreen">
      <div className="mainCon">
        <div className="innerContainer">
          <div className="leftNav">
            <Button type='default' className="prevBtn" onClick={moveToOutputTable} >
              <ArrowLeftOutlined className="arrow" />
            </Button>
            <p className='pText' style={{ color: '#3F4047' }}> TATA communication</p>
            </div>
            <div style={{ display: "flex", marginRight: "60px" }}>

              {!isDocumentPage && (
                <Button type='default' className="prevBtn" onClick={handlePrevious} >
                  <ArrowLeftOutlined className="arrow" />
                  Previous
                </Button>
              )}
              <div>
                {!isDocumentPage && (
                  <Button type='default' className="nextBtn">
                    {`${countValues} of ${filterAppliedValue}`}
                  </Button>
                )}
              </div>
            </div>
          
          
        </div>

        <div className="container">
          <div className="leftSide">
            <div className="pdfViewer">
              {pdfUrl ? (
                <div className="pdfContainer">
                  <iframe
                    src={pdfUrl}
                    title="S3 PDF"
                  />
                </div>
              ) : imageSrc ? (
                <div className="imageContainer">
                  <iframe
                    src={imageSrc}
                    alt="Document"
                    title="Document Image"
                  />
                </div>
              ) : (
                <p>No documents</p>
              )}
            </div>
          </div>


          <Modal
            title="Manual Validation Completed"
            visible={isModalVisible}
            onOk={handleOkMatches}
            onCancel={handleCancelMatches}
          >
            <p>Manual Validation completed</p>
          </Modal>

          <div style={{ width: '50%', marginRight:"10px" }} className="rightSide">
            {!showBookingTable && currentDoc && (
              <div className="formData">
                <table className="table1Data">
                  <thead>
                    <tr>
                      <th className="data-title">Data from Invoice</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="data-label">Supplier</td>
                      <td className="data-separator">:</td>
                      <td className="data-value">{currentDoc.df_A.supplier_name}</td>
                    </tr>
                    <tr>
                      <td className="data-label">Supplier GSTIN</td>
                      <td className="data-separator">:</td>
                      <td className="data-value1">{currentDoc.df_A.seller_vat_number}</td>
                    </tr>
                    <tr>
                      <td className="data-label">Invoice number</td>
                      <td className="data-separator">:</td>
                      <td className="data-value2">{currentDoc.df_A.invoice_number}</td>
                    </tr>
                    <tr>
                      <td className="data-label">Invoice date</td>
                      <td className="data-separator">:</td>
                      <td className="data-value3">{currentDoc.df_A.invoice_date}</td>
                    </tr>
                    <tr>
                      <td className="data-label">Invoice amount</td>
                      <td className="data-separator">:</td>
                      <td className="data-value4">INR {currentDoc.df_A.invoice_amount}</td>
                    </tr>
                  </tbody>
                </table>
                <table className="styled-table">
                  <thead>
                    <tr>
                      <th></th>
                      {currentDoc.df_B.map((_, idx) => (
                        <th
                          key={idx
                          } className={selectedColumn.includes(idx) ? "selected" : ""}  >
                          <input type="checkBox"
                            checked={selectedColumn.includes(idx)}
                            onChange={() => handleCheckboxChange(idx)}
                          />
                          {`2B MATCH ${idx + 1}`}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Supplier</td>
                      {currentDoc.df_B.map((doc, idx) => (
                        <td key={idx}
                          className={selectedColumn.includes(idx) ? 'selected' : ''}>
                          {doc.trdnm || "N/A"}
                        </td>
                      ))}
                    </tr>
                    <tr>
                      <td>Supplier GSTIN</td>
                      {currentDoc.df_B.map((doc, idx) => {
                        const styles = getColor(parseInt(doc.gstin_score));
                        return (
                          <td key={idx}
                            className={selectedColumn.includes(idx) ? 'selected' : ''}>
                            <div className="score-container">
                              {doc.ctin || "N/A"}
                              <div
                                className="score-badge"
                                style={{
                                  color: styles.textColor,
                                  backgroundColor: styles.backgroundColor,
                                  borderColor: styles.borderColor,
                                  border: `1px solid ${styles.borderColor}`
                                }}
                              >
                                {parseInt(doc.gstin_score)}%
                              </div>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <td>Invoice Number</td>
                      {currentDoc.df_B.map((doc, idx) => {
                        const styles = getColor(parseInt(doc.inv_no_score));
                        return (
                          <td key={idx}
                            className={selectedColumn.includes(idx) ? 'selected' : ''}>
                            <div className="score-container">
                              {doc.inum || "N/A"}
                              <div
                                className="score-badge"
                                style={{
                                  color: styles.textColor,
                                  backgroundColor: styles.backgroundColor,
                                  borderColor: styles.borderColor,
                                  border: `1px solid ${styles.borderColor}`
                                }}
                              >
                                {parseInt(doc.inv_no_score)}%
                              </div>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <td>Invoice Value</td>
                      {currentDoc.df_B.map((doc, idx) => {
                        const styles = getColor(parseInt(doc.amount_score));
                        return (
                          <td key={idx}
                            className={selectedColumn.includes(idx) ? 'selected' : ''}>
                            <div className="score-container">
                              {doc.val || "N/A"}
                              <div
                                className="score-badge"
                                style={{
                                  color: styles.textColor,
                                  backgroundColor: styles.backgroundColor,
                                  borderColor: styles.borderColor,
                                  border: `1px solid ${styles.borderColor}`
                                }}
                              >
                                {parseInt(doc.amount_score)}%
                              </div>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <td>Invoice Date</td>
                      {currentDoc.df_B.map((doc, idx) => {
                        const styles = getColor(parseInt(doc.date_score));
                        return (
                          <td key={idx}
                            className={selectedColumn.includes(idx) ? 'selected' : ''}>
                            <div className="score-container">
                              <span>{doc?.dt || doc?.invoice_date || "N/A"}</span>
                              <div
                                className="score-badge"
                                style={{
                                  color: styles.textColor,
                                  backgroundColor: styles.backgroundColor,
                                  borderColor: styles.borderColor,
                                  border: `1px solid ${styles.borderColor}`,

                                }}
                              >
                                {parseInt(doc.date_score)}%
                              </div>
                            </div>
                          </td>
                        );
                      })}
                    </tr>
                    <tr>
                      <td style={{ padding: '3px 10px' }}>
                        <strong>Total Match Score</strong>
                      </td>
                      {currentDoc.df_B.map((doc, idx) => (
                        <td key={idx}
                          className={selectedColumn.includes(idx) ? 'selected' : ''}
                          style={{ textAlign: 'right', padding: '3px 10px' }}>
                          <button
                            style={{
                              backgroundColor: '#F1FCF3',
                              color: '#1E7734',
                              border: '1px solid #C0F2CC',
                              padding: '2px 10px',
                              cursor: 'pointer',
                              borderRadius: '16px'
                            }}
                          >
                            {doc.combined_score ? `${doc.combined_score}%` : "N/A"}
                          </button>
                        </td>
                      ))}
                    </tr>

                  </tbody>
                </table>
              </div>
            )}

            <div className="remarkSection" >
              <div className="reText">
                <label className="remark">Remarks</label>
                <textarea placeholder="Write here" className="text"
                  value={remarks}
                  onChange={handleRemarksChange}>
                </textarea>
              </div>

              <div className="btnAdd">

                {showNoMatchFound && (
                  <div>
                    <Button onClick={handleNoMatchFound} className="button1">No Match</Button>
                    <Button onClick={handleSkip} className="button2">Skip <DoubleRightOutlined className="skipArr" /></Button>
                  </div>
                )}
                {showPerfectMatchAndMatch && (
                  <div>
                    <Button onClick={handlePerfectMatch} className="Pmatch">Perfect Match</Button>
                    <Button onClick={handleMatch} className="match">Match</Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
};

export default App;


